import { render, staticRenderFns } from "./BillingSettingsPage.vue?vue&type=template&id=fe506904&scoped=true"
import script from "./BillingSettingsPage.vue?vue&type=script&lang=js"
export * from "./BillingSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./BillingSettingsPage.vue?vue&type=style&index=0&id=fe506904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe506904",
  null
  
)

export default component.exports